











import CircleIcon from '@/components/CircleIcon.vue'
import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  components: { CircleIcon },
  props: {
    name: {
      type: String,
      default: 'NAME',
      required: true
    },
    job: {
      type: String,
      default: 'JOB',
      required: true
    },
    profileIcon: {
      required: true
    }
  }
})
